module.exports = {
	company: 'company',
	team: 'team',
};
